var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPhoneVerify = function SvgPhoneVerify(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79.942,
    height: 79.942,
    viewBox: "0 0 79.942 79.942",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2184",
    "data-name": "Group 2184",
    transform: "translate(17223 11877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    d: "M39.971,0A39.971,39.971,0,1,1,0,39.971,39.971,39.971,0,0,1,39.971,0Z",
    transform: "translate(-17223 -11877)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "group-76",
    transform: "translate(-17195.791 -11860.043)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rectangle",
    width: 24.877,
    height: 46.474,
    rx: 3,
    strokeWidth: 0.5,
    fill: "#ededed",
    stroke: "#585858",
    strokeMiterlimit: 10,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse",
    cx: 2.053,
    cy: 2.053,
    rx: 2.053,
    ry: 2.053,
    transform: "translate(10.693 40.577)",
    fill: "#fff",
    stroke: "#585858",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rectangle-2",
    "data-name": "rectangle",
    width: 4.785,
    height: 0.87,
    rx: 0.435,
    transform: "translate(10.044 3.539)",
    fill: "#fff",
    stroke: "#585858",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rectangle-3",
    "data-name": "rectangle",
    width: 0.87,
    height: 0.87,
    rx: 0.435,
    transform: "translate(12.872 2.736) rotate(180)",
    fill: "#fff",
    stroke: "#585858",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rectangle-4",
    "data-name": "rectangle",
    width: 24.877,
    height: 33.641,
    transform: "translate(0 6.031)",
    fill: "#fff",
    stroke: "#585858",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    d: "M5.257,0V0Z",
    transform: "translate(-17189.041 -11838.304)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoneVerify, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phoneVerify.a83f8435.svg";
export { ForwardRef as ReactComponent };